export default function ExclusiveDeals() {
  const deals = [
    {
      icon: 'ri-percent-line',
      title: 'Exclusive Discounts',
      description: 'Access special rates through our trusted partnerships with leading hotels'
    },
    {
      icon: 'ri-time-line',
      title: 'Last-Minute Offers',
      description: 'Grab amazing deals on premium accommodations with flexible booking'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Seasonal Promotions',
      description: 'Take advantage of special offers during peak and off-peak seasons'
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Package Deals',
      description: 'Combined flight and accommodation packages for maximum savings'
    }
  ];

  return (
    <section className="py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/5542382ad14f31a644dc98dde47e962a.jpg"
                alt="Exclusive Travel Deals"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-[#C9A961]/20 rounded-3xl -z-10"></div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-block px-4 py-2 bg-[#C9A961]/10 rounded-full mb-4">
              <span className="text-[#C9A961] text-sm font-semibold">Exclusive Partnerships</span>
            </div>
            <h2 className="text-5xl font-bold text-[#1A1F2E] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Exclusive Deals Through Trusted Partnerships
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We work closely with leading travel providers, giving you access to exclusive benefits. Our partnerships allow us to negotiate better rates while maintaining quality — helping you save more without compromising your travel experience.
            </p>

            <div className="space-y-6 mb-8">
              {deals.map((deal, index) => (
                <div key={index} className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all">
                  <div className="w-12 h-12 bg-[#C9A961] rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${deal.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-[#1A1F2E] mb-2">{deal.title}</h4>
                    <p className="text-gray-600">{deal.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 p-6 bg-[#C9A961]/10 rounded-xl">
              <i className="ri-shield-check-line text-3xl text-[#C9A961]"></i>
              <div>
                <h4 className="font-bold text-[#1A1F2E] mb-1">Best Price Guarantee</h4>
                <p className="text-sm text-gray-600">We ensure you get the best available rates on all bookings</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
